import { Params } from "@angular/router";

export interface RedirectState {
	queryParams: Params | null;
	url: string | null;
}

export const initialRedirectState: RedirectState = {
	queryParams: null,
	url: null
};
